import React from 'react'
import Modal from '../Modal'
import Button from '../Button'
import AlertTriangle from '../../assets/img/alert-triangle.png'
import './ErrorModal.css'

const ErrorModal = props => {
  const { title, subtitle, isOpen, onRequestClose } = props
  return (
    <Modal size="md" isOpen={isOpen} onRequestClose={onRequestClose}>
      <div className="cookunity__error_modal">
        <img src={AlertTriangle} alt="alert triangle" />
        <h1>{title}</h1>
        <p>{subtitle}</p>
        <Button dark large onClick={onRequestClose}>
          Try Again
        </Button>
      </div>
    </Modal>
  )
}

export default ErrorModal



// WEBPACK FOOTER //
// ./src/components/ErrorModal/ErrorModal.jsx